export const handleSelected = (data, id) => {
  if (!data.includes(id)) {
    return [...data, id];
  }

  return data.filter((item) => item !== id);
};

export const handleSelectedProject = (data, projectInfo) => {
  if (!data.includes(projectInfo)) {
    return [...data, projectInfo];
  }

  return data.filter((item) => item.id !== projectInfo.id);
};
